// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page shell ───────────────────────────────────────────────────────────── */

.scl--cms-pages-dashboard {
  width: 100%;
  max-width: 1920px;
  padding: 0px 130px 20px 130px;
  background: transparent;
  font-family: 'Inter', sans-serif;
}

/* ── Header ───────────────────────────────────────────────────────────────── */

.scl--cms-pages-dashboard-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0px;
  margin-bottom: 10px;
  width: 100%;
  height: 82px;
  box-sizing: border-box;
}

.scl--cms-pages-dashboard-header-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.scl--cms-pages-dashboard-title {
  font-weight: 600;
  font-size: 36px;
  line-height: 40px;
  color: #323539;
  margin: 0;
}

.scl--cms-pages-dashboard-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #8A8B8F;
  margin: 0;
  letter-spacing: -0.01em;
}

.scl--cms-pages-dashboard-add-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  height: 30px;
  background: #4E9FFF;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  flex-shrink: 0;
  transition: background 0.15s;
}

.scl--cms-pages-dashboard-add-btn:hover { background: #3a8ff0; }

.scl--cms-pages-dashboard-add-divider {
  display: inline-block;
  width: 1px;
  height: 17px;
  background: rgba(241, 243, 247, 0.2);
}

/* ── Content area ─────────────────────────────────────────────────────────── */

.scl--cms-pages-dashboard-content {
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding: 0 0 24px;
}

/* ── Section header ───────────────────────────────────────────────────────── */

.scl--cms-pages-dashboard-section-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 11px;
  width: 100%;
  height: 25px;
}

.scl--cms-pages-dashboard-section-title {
  background: none;
  border: none;
  padding: 5px 20px 5px 0px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: #323539;
  text-align: left;
}
.scl--cms-pages-dashboard-section-title:hover{
  text-decoration: underline;
}

.scl--cms-pages-dashboard-see-more {
  background: none;
  border: none;
  padding-left: 5px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.1px;
  color: #2388FF;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
}

.scl--cms-pages-dashboard-see-more:hover {
  text-decoration: underline;
}

/* ── Stat cards row ───────────────────────────────────────────────────────── */

.scl--cms-pages-dashboard-cards-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
}

/* ── Charts row — Career 55% / Media 45% ─────────────────────────────────── */

.scl--cms-pages-dashboard-charts-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  height: 364px;
}

.scl--cms-pages-dashboard-charts-row > :first-child {
  flex: 0 0 calc(55% - 8px);
  width: calc(55% - 8px);
  min-width: 0;
  height: 100%;
}

.scl--cms-pages-dashboard-charts-row > :last-child {
  flex: 0 0 calc(45% - 8px);
  width: calc(45% - 8px);
  min-width: 0;
  height: 100%;
}

/* ── Shared card styles ───────────────────────────────────────────────────── */

.scl--cms-pages-dashboard-chart-card {
  position: relative;
  background: #FFFFFF;
  border: 1px solid #E5E5E7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.scl--cms-pages-dashboard-card-header {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 20px;
  height: 56px;
  border-bottom: 1px solid #E5E5E7;
  flex-shrink: 0;
}

.scl--cms-pages-dashboard-card-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: #323539;
  flex: 1;
}

.scl--cms-pages-dashboard-dots-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}

/* ── Media chart ──────────────────────────────────────────────────────────── */

.scl--cms-pages-dashboard-media-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 20px;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

.scl--cms-pages-dashboard-donut-wrap {
  position: relative;
  flex-shrink: 0;
  width: 207px;
  height: 227px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scl--cms-pages-dashboard-donut-tooltip {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: #FFFFFF;
  border: 0.74px solid #E1E4ED;
  box-shadow: 0px 0.74px 2.94px rgba(25, 33, 61, 0.08);
  border-radius: 3px;
  padding: 4px 6px;
  font-size: 10px;
  font-weight: 600;
  color: #353E5C;
  white-space: nowrap;
  z-index: 2;
}

.scl--cms-pages-dashboard-donut-svg { display: block; }

.scl--cms-pages-dashboard-donut-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  pointer-events: none;
}

.scl--cms-pages-dashboard-donut-label {
  font-size: 12px;
  line-height: 20px;
  color: #8A8B8F;
  text-align: center;
}

.scl--cms-pages-dashboard-donut-value {
  font-weight: 600;
  font-size: 36px;
  line-height: 40px;
  color: #323539;
  text-align: center;
}

.scl--cms-pages-dashboard-donut-sub {
  font-size: 12px;
  line-height: 20px;
  color: #8A8B8F;
  text-align: center;
}

.scl--cms-pages-dashboard-media-stats {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.scl--cms-pages-dashboard-media-legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0;
  gap: 57px;
  border-bottom: 1px solid #E5E5E7;
}

.scl--cms-pages-dashboard-media-legend-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.scl--cms-pages-dashboard-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 5px;
  flex-shrink: 0;
}

.scl--cms-pages-dashboard-legend-name {
  font-size: 16px;
  line-height: 22px;
  color: #323539;
}

.scl--cms-pages-dashboard-legend-count {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323539;
}

.scl--cms-pages-dashboard-media-bars {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.scl--cms-pages-dashboard-media-stat {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.scl--cms-pages-dashboard-media-stat-heading {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.scl--cms-pages-dashboard-media-stat-label {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #8A8B8F;
}

.scl--cms-pages-dashboard-media-stat-val {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323539;
}

.scl--cms-pages-dashboard-progress-track {
  width: 100%;
  height: 10px;
  background: #F1F3F7;
  box-shadow: inset 0px 2px 2px rgba(165, 165, 165, 0.04);
  border-radius: 6px;
  overflow: hidden;
}

.scl--cms-pages-dashboard-progress-bar {
  height: 100%;
  border-radius: 6px;
  transition: width 0.4s ease;
}

.scl--cms-pages-dashboard-media-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 4px;
  border-top: 1px solid #E5E5E7;
  margin-top: auto;
}

.scl--cms-pages-dashboard-media-link {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.1px;
  color: #2388FF;
  text-decoration: none;
}

.scl--cms-pages-dashboard-open-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #4E9FFF;
  padding: 0;
}

/* ── Bottom row — Inbox 30% / Notification 70% ───────────────────────────── */

.scl--cms-pages-dashboard-bottom-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;   /* children stretch to match tallest sibling */
  gap: 16px;
  width: 100%;
  min-height: 548px;      /* gives children a concrete height to resolve against */
}

.scl--cms-pages-dashboard-bottom-row > :first-child {
  flex: 0 0 calc(30% - 8px);
  width: calc(30% - 8px);
  min-width: 0;
  max-width: unset !important;
  align-self: stretch;
  display: flex;
  flex-direction: column;
}

.scl--cms-pages-dashboard-bottom-row > :last-child {
  flex: 0 0 calc(70% - 8px);
  width: calc(70% - 8px);
  min-width: 0;
  align-self: stretch;
  display: flex;
  flex-direction: column;
}

/* ── Inbox card ───────────────────────────────────────────────────────────── */

.scl--cms-pages-dashboard-inbox-card {
  box-sizing: border-box;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E5E5E7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.scl--cms-pages-dashboard-inbox-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 20px;
  gap: 16px;
  flex: 1;
}

.scl--cms-pages-dashboard-inbox-donut-wrap {
  position: relative;
  width: 240px;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scl--cms-pages-dashboard-inbox-tooltip {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: #FFFFFF;
  border: 0.74px solid #E1E4ED;
  box-shadow: 0px 0.74px 2.94px rgba(25, 33, 61, 0.08);
  border-radius: 3px;
  padding: 4px 6px;
  font-size: 10px;
  font-weight: 600;
  color: #353E5C;
  white-space: nowrap;
  z-index: 2;
}

.scl--cms-pages-dashboard-inbox-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.scl--cms-pages-dashboard-inbox-value {
  font-weight: 600;
  font-size: 36px;
  line-height: 40px;
  color: #323539;
  text-align: center;
}

.scl--cms-pages-dashboard-inbox-legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.scl--cms-pages-dashboard-inbox-footer {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 10px;
  height: 51px;
  border-top: 1px solid #E5E5E7;
  flex-shrink: 0;
}

.scl--cms-pages-dashboard-notif-card {
  width: 100%;
  box-sizing: border-box;
  background: #FFFFFF;
  border: 1px solid #E5E5E7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

.scl--cms-pages-dashboard-notif-thead {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #F8F9FB;
  border-bottom: 1px solid #E5E5E7;
  padding: 0;
  height: 34px;
  flex-shrink: 0;
}

.scl--cms-pages-dashboard-notif-th {
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: -0.1px;
  color: #858C95;
  padding: 0 24px;
}

.scl--cms-pages-dashboard-notif-th--date {
  width: 145px;
  flex-shrink: 0;
}

.scl--cms-pages-dashboard-notif-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
}

.scl--cms-pages-dashboard-notif-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: 92.5px;
  border-bottom: 1px solid #E5E5E7;
  box-sizing: border-box;
}

.scl--cms-pages-dashboard-notif-date {
  width: 145px;
  flex-shrink: 0;
  font-size: 16px;
  line-height: 30px;
  color: #858C95;
  padding: 12px 24px;
  box-sizing: border-box;
}

.scl--cms-pages-dashboard-notif-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 24px;
  gap: 26px;
  flex: 1;
  min-width: 0;
}

.scl--cms-pages-dashboard-notif-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
}

.scl--cms-pages-dashboard-notif-text {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
  min-width: 0;
}

.scl--cms-pages-dashboard-notif-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #111927;
}

.scl--cms-pages-dashboard-notif-desc {
  font-size: 12px;
  line-height: 18px;
  color: #858C95;
}


.scl--cms-pages-dashboard .scl-components-button-RoundSqureButton.scl-components-button-RoundSqureButton-primary.scl-components-button-RoundSqureButton-md .scl-components-button-RoundSqureButton-icon {
  padding-left: 8px;
  border-left: 1px solid #F1F3F733 !important;
  margin-left: 4px !important;
  height: 16px;
  font-size: 20px;
  margin-right: none;
}
.scl--cms-pages-dashboard .scl-components-button-RoundSqureButton.scl-components-button-RoundSqureButton-primary.scl-components-button-RoundSqureButton-md .scl-components-button-RoundSqureButton-icon svg{
  height: 16px;
}
.scl--cms-pages-dashboard .scl-components-button-RoundSqureButton.scl-components-button-RoundSqureButton-primary.scl-components-button-RoundSqureButton-md .scl-components-button-RoundSqureButton-icon svg path{

  stroke: white;
}

.scl--cms-pages-dashboard-add-wrapper {
  position: relative;
  flex-shrink: 0;
}

/* ── Dropdown popup ───────────────────────────────────────────────────────── */

.scl--cms-pages-dashboard-dropdown {
  position: absolute;
  padding: 5px 0;
  top: calc(100% + 6px);
  right: 0;
  width: 150px;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  z-index: 100;

  /* Animate in */
  animation: scl-dropdown-in 0.12s ease-out;
}

@keyframes scl-dropdown-in {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

.scl--cms-pages-dashboard-dropdown-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  padding: 10px 18px;
  width: 100%;
  height: 30px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8A8B8F;
  text-align: left;
  box-sizing: border-box;
  transition: background 0.1s;
}

.scl--cms-pages-dashboard-dropdown-item:hover {
  background: #F8F9FB;
  color: #323539;
}

.scl--cms-pages-dashboard-dropdown-item svg path,
.scl--cms-pages-dashboard-dropdown-item svg rect,
.scl--cms-pages-dashboard-dropdown-item svg line {
  transition: stroke 0.1s;
}

.scl--cms-pages-dashboard-dropdown-item:hover svg path,
.scl--cms-pages-dashboard-dropdown-item:hover svg rect,
.scl--cms-pages-dashboard-dropdown-item:hover svg line {
  stroke: #0f1113;
}
.scl--components-alert-notification{
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/dashboard/css/dashboardPage.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,4BAA4B;AAC9B;;AAEA,0CAA0C,mBAAmB,EAAE;;AAE/D;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA,sCAAsC,cAAc,EAAE;;AAEtD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB,IAAI,8CAA8C;EACtE,SAAS;EACT,WAAW;EACX,iBAAiB,OAAO,wDAAwD;AAClF;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,gFAAgF;;AAEhF;EACE,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;;EAEZ,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;EAGE,eAAe;AACjB;AACA;EACE,YAAY;AACd","sourcesContent":["/* ── Page shell ───────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard {\n  width: 100%;\n  max-width: 1920px;\n  padding: 0px 130px 20px 130px;\n  background: transparent;\n  font-family: 'Inter', sans-serif;\n}\n\n/* ── Header ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0px;\n  margin-bottom: 10px;\n  width: 100%;\n  height: 82px;\n  box-sizing: border-box;\n}\n\n.scl--cms-pages-dashboard-header-content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.scl--cms-pages-dashboard-title {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 40px;\n  color: #323539;\n  margin: 0;\n}\n\n.scl--cms-pages-dashboard-description {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #8A8B8F;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.scl--cms-pages-dashboard-add-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 8px;\n  height: 30px;\n  background: #4E9FFF;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #FFFFFF;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n\n.scl--cms-pages-dashboard-add-btn:hover { background: #3a8ff0; }\n\n.scl--cms-pages-dashboard-add-divider {\n  display: inline-block;\n  width: 1px;\n  height: 17px;\n  background: rgba(241, 243, 247, 0.2);\n}\n\n/* ── Content area ─────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard-content {\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n  padding: 0 0 24px;\n}\n\n/* ── Section header ───────────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard-section-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 11px;\n  width: 100%;\n  height: 25px;\n}\n\n.scl--cms-pages-dashboard-section-title {\n  background: none;\n  border: none;\n  padding: 5px 20px 5px 0px;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: -0.01em;\n  color: #323539;\n  text-align: left;\n}\n.scl--cms-pages-dashboard-section-title:hover{\n  text-decoration: underline;\n}\n\n.scl--cms-pages-dashboard-see-more {\n  background: none;\n  border: none;\n  padding-left: 5px;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.1px;\n  color: #2388FF;\n  text-decoration: none;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-dashboard-see-more:hover {\n  text-decoration: underline;\n}\n\n/* ── Stat cards row ───────────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard-cards-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n\n/* ── Charts row — Career 55% / Media 45% ─────────────────────────────────── */\n\n.scl--cms-pages-dashboard-charts-row {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 16px;\n  width: 100%;\n  height: 364px;\n}\n\n.scl--cms-pages-dashboard-charts-row > :first-child {\n  flex: 0 0 calc(55% - 8px);\n  width: calc(55% - 8px);\n  min-width: 0;\n  height: 100%;\n}\n\n.scl--cms-pages-dashboard-charts-row > :last-child {\n  flex: 0 0 calc(45% - 8px);\n  width: calc(45% - 8px);\n  min-width: 0;\n  height: 100%;\n}\n\n/* ── Shared card styles ───────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard-chart-card {\n  position: relative;\n  background: #FFFFFF;\n  border: 1px solid #E5E5E7;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.scl--cms-pages-dashboard-card-header {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 20px;\n  height: 56px;\n  border-bottom: 1px solid #E5E5E7;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-dashboard-card-title {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: -0.01em;\n  color: #323539;\n  flex: 1;\n}\n\n.scl--cms-pages-dashboard-dots-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Media chart ──────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard-media-body {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 20px;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n}\n\n.scl--cms-pages-dashboard-donut-wrap {\n  position: relative;\n  flex-shrink: 0;\n  width: 207px;\n  height: 227px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scl--cms-pages-dashboard-donut-tooltip {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #FFFFFF;\n  border: 0.74px solid #E1E4ED;\n  box-shadow: 0px 0.74px 2.94px rgba(25, 33, 61, 0.08);\n  border-radius: 3px;\n  padding: 4px 6px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #353E5C;\n  white-space: nowrap;\n  z-index: 2;\n}\n\n.scl--cms-pages-dashboard-donut-svg { display: block; }\n\n.scl--cms-pages-dashboard-donut-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  pointer-events: none;\n}\n\n.scl--cms-pages-dashboard-donut-label {\n  font-size: 12px;\n  line-height: 20px;\n  color: #8A8B8F;\n  text-align: center;\n}\n\n.scl--cms-pages-dashboard-donut-value {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 40px;\n  color: #323539;\n  text-align: center;\n}\n\n.scl--cms-pages-dashboard-donut-sub {\n  font-size: 12px;\n  line-height: 20px;\n  color: #8A8B8F;\n  text-align: center;\n}\n\n.scl--cms-pages-dashboard-media-stats {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n}\n\n.scl--cms-pages-dashboard-media-legend {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 0;\n  gap: 57px;\n  border-bottom: 1px solid #E5E5E7;\n}\n\n.scl--cms-pages-dashboard-media-legend-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.scl--cms-pages-dashboard-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 5px;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-dashboard-legend-name {\n  font-size: 16px;\n  line-height: 22px;\n  color: #323539;\n}\n\n.scl--cms-pages-dashboard-legend-count {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 24px;\n  color: #323539;\n}\n\n.scl--cms-pages-dashboard-media-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.scl--cms-pages-dashboard-media-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.scl--cms-pages-dashboard-media-stat-heading {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.scl--cms-pages-dashboard-media-stat-label {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8A8B8F;\n}\n\n.scl--cms-pages-dashboard-media-stat-val {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 24px;\n  color: #323539;\n}\n\n.scl--cms-pages-dashboard-progress-track {\n  width: 100%;\n  height: 10px;\n  background: #F1F3F7;\n  box-shadow: inset 0px 2px 2px rgba(165, 165, 165, 0.04);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.scl--cms-pages-dashboard-progress-bar {\n  height: 100%;\n  border-radius: 6px;\n  transition: width 0.4s ease;\n}\n\n.scl--cms-pages-dashboard-media-footer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 4px;\n  border-top: 1px solid #E5E5E7;\n  margin-top: auto;\n}\n\n.scl--cms-pages-dashboard-media-link {\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.1px;\n  color: #2388FF;\n  text-decoration: none;\n}\n\n.scl--cms-pages-dashboard-open-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #4E9FFF;\n  padding: 0;\n}\n\n/* ── Bottom row — Inbox 30% / Notification 70% ───────────────────────────── */\n\n.scl--cms-pages-dashboard-bottom-row {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;   /* children stretch to match tallest sibling */\n  gap: 16px;\n  width: 100%;\n  min-height: 548px;      /* gives children a concrete height to resolve against */\n}\n\n.scl--cms-pages-dashboard-bottom-row > :first-child {\n  flex: 0 0 calc(30% - 8px);\n  width: calc(30% - 8px);\n  min-width: 0;\n  max-width: unset !important;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n}\n\n.scl--cms-pages-dashboard-bottom-row > :last-child {\n  flex: 0 0 calc(70% - 8px);\n  width: calc(70% - 8px);\n  min-width: 0;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Inbox card ───────────────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard-inbox-card {\n  box-sizing: border-box;\n  width: 100%;\n  background: #FFFFFF;\n  border: 1px solid #E5E5E7;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.scl--cms-pages-dashboard-inbox-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px 20px;\n  gap: 16px;\n  flex: 1;\n}\n\n.scl--cms-pages-dashboard-inbox-donut-wrap {\n  position: relative;\n  width: 240px;\n  height: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scl--cms-pages-dashboard-inbox-tooltip {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #FFFFFF;\n  border: 0.74px solid #E1E4ED;\n  box-shadow: 0px 0.74px 2.94px rgba(25, 33, 61, 0.08);\n  border-radius: 3px;\n  padding: 4px 6px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #353E5C;\n  white-space: nowrap;\n  z-index: 2;\n}\n\n.scl--cms-pages-dashboard-inbox-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.scl--cms-pages-dashboard-inbox-value {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 40px;\n  color: #323539;\n  text-align: center;\n}\n\n.scl--cms-pages-dashboard-inbox-legend {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.scl--cms-pages-dashboard-inbox-footer {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 10px;\n  height: 51px;\n  border-top: 1px solid #E5E5E7;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-dashboard-notif-card {\n  width: 100%;\n  box-sizing: border-box;\n  background: #FFFFFF;\n  border: 1px solid #E5E5E7;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.scl--cms-pages-dashboard-notif-thead {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background: #F8F9FB;\n  border-bottom: 1px solid #E5E5E7;\n  padding: 0;\n  height: 34px;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-dashboard-notif-th {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 18px;\n  letter-spacing: -0.1px;\n  color: #858C95;\n  padding: 0 24px;\n}\n\n.scl--cms-pages-dashboard-notif-th--date {\n  width: 145px;\n  flex-shrink: 0;\n}\n\n.scl--cms-pages-dashboard-notif-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.scl--cms-pages-dashboard-notif-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  min-height: 92.5px;\n  border-bottom: 1px solid #E5E5E7;\n  box-sizing: border-box;\n}\n\n.scl--cms-pages-dashboard-notif-date {\n  width: 145px;\n  flex-shrink: 0;\n  font-size: 16px;\n  line-height: 30px;\n  color: #858C95;\n  padding: 12px 24px;\n  box-sizing: border-box;\n}\n\n.scl--cms-pages-dashboard-notif-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 12px 24px;\n  gap: 26px;\n  flex: 1;\n  min-width: 0;\n}\n\n.scl--cms-pages-dashboard-notif-avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background-size: cover;\n  background-position: center;\n}\n\n.scl--cms-pages-dashboard-notif-text {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  flex: 1;\n  min-width: 0;\n}\n\n.scl--cms-pages-dashboard-notif-title {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #111927;\n}\n\n.scl--cms-pages-dashboard-notif-desc {\n  font-size: 12px;\n  line-height: 18px;\n  color: #858C95;\n}\n\n\n.scl--cms-pages-dashboard .scl-components-button-RoundSqureButton.scl-components-button-RoundSqureButton-primary.scl-components-button-RoundSqureButton-md .scl-components-button-RoundSqureButton-icon {\n  padding-left: 8px;\n  border-left: 1px solid #F1F3F733 !important;\n  margin-left: 4px !important;\n  height: 16px;\n  font-size: 20px;\n  margin-right: none;\n}\n.scl--cms-pages-dashboard .scl-components-button-RoundSqureButton.scl-components-button-RoundSqureButton-primary.scl-components-button-RoundSqureButton-md .scl-components-button-RoundSqureButton-icon svg{\n  height: 16px;\n}\n.scl--cms-pages-dashboard .scl-components-button-RoundSqureButton.scl-components-button-RoundSqureButton-primary.scl-components-button-RoundSqureButton-md .scl-components-button-RoundSqureButton-icon svg path{\n\n  stroke: white;\n}\n\n.scl--cms-pages-dashboard-add-wrapper {\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* ── Dropdown popup ───────────────────────────────────────────────────────── */\n\n.scl--cms-pages-dashboard-dropdown {\n  position: absolute;\n  padding: 5px 0;\n  top: calc(100% + 6px);\n  right: 0;\n  width: 150px;\n  background: #FFFFFF;\n  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.05);\n  border-radius: 5px;\n  overflow: hidden;\n  z-index: 100;\n\n  /* Animate in */\n  animation: scl-dropdown-in 0.12s ease-out;\n}\n\n@keyframes scl-dropdown-in {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.scl--cms-pages-dashboard-dropdown-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 15px;\n  padding: 10px 18px;\n  width: 100%;\n  height: 30px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #8A8B8F;\n  text-align: left;\n  box-sizing: border-box;\n  transition: background 0.1s;\n}\n\n.scl--cms-pages-dashboard-dropdown-item:hover {\n  background: #F8F9FB;\n  color: #323539;\n}\n\n.scl--cms-pages-dashboard-dropdown-item svg path,\n.scl--cms-pages-dashboard-dropdown-item svg rect,\n.scl--cms-pages-dashboard-dropdown-item svg line {\n  transition: stroke 0.1s;\n}\n\n.scl--cms-pages-dashboard-dropdown-item:hover svg path,\n.scl--cms-pages-dashboard-dropdown-item:hover svg rect,\n.scl--cms-pages-dashboard-dropdown-item:hover svg line {\n  stroke: #0f1113;\n}\n.scl--components-alert-notification{\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
